import * as React from "react";

function SvgPlay(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      viewBox="0 0 19.88 23.96"
      focusable={false}
      role="presentation"
      aria-hidden={true}
      {...props}
    >
      <path d="M19.88 12a1.47 1.47 0 01-.61 1L2.26 23.6c-1.28.81-2.28.21-2.28-1.34V1.7C-.02.15.98-.45 2.26.36L19.28 11a1.5 1.5 0 01.6 1z" />
    </svg>
  );
}

const MemoSvgPlay = React.memo(SvgPlay);
export default MemoSvgPlay;
